import { invokeApiGateway } from '../../auth/api-client';

export interface QueueStats {
  name: string;
  url: string;
  messagesAvailable: number;
  messagesInFlight: number;
  oldestMessageAge: number;
  lastUpdated: string;
}

export async function getSqsStatus(env: string) {
  return invokeApiGateway(`/debug/sqs/status?env=${env.toLowerCase()}`);
}

export async function fetchQueueStats(env: string): Promise<{ trigger: QueueStats; dlq: QueueStats }> {
  const data = await getSqsStatus(env);
  const tq = data.triggerQueue || {};
  const dq = data.dlq || {};
  return {
    trigger: {
      name: 'cs-trigger-queue.fifo',
      url: '',
      messagesAvailable: tq.messages || 0,
      messagesInFlight: tq.inFlight || 0,
      oldestMessageAge: 0,
      lastUpdated: new Date().toISOString(),
    },
    dlq: {
      name: 'cs-trigger-dlq.fifo',
      url: '',
      messagesAvailable: dq.messages || 0,
      messagesInFlight: dq.inFlight || 0,
      oldestMessageAge: 0,
      lastUpdated: new Date().toISOString(),
    },
  };
}